import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  IconButton,
  Typography,
  Tooltip,
  Paper,
  Drawer,
  Avatar,
  TextField,
  InputAdornment,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/Apps/users/userSlice";
import { createNewOpenFormName } from "../../../static/staticdata";
import UserAvatar from "../../UserAvatar";
import {
  ClearRounded,
  CloseRounded,
  LogoutRounded,
  PersonRounded,
  LoginRounded,
} from "@mui/icons-material";
import {
  getFirmData,
  getLoginUserData,
} from "../../../redux/Apps/Lawyerapp/DashboardSlice/DashboardSlice";
import { backend_api } from "../../../static/server";
import { pageScrollStyle } from "../../../styles/styles";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { useDialog } from "../../DialogContext";
import Stopwatch from "./Stopwatch";
import InviteUserForm from "../../../pages/LawyerPages/TeamMembers/Users Form/InviteUserForm";
import { persistor } from "../../../redux/store";
import { useCustomTheme } from "../../../pages/LawyerPages/Settings/useTheme";
import CreateTaskForm from "../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskForm";
import CreateTaskTemplateForm from "../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskTemplateForm";
import CreateTaskListForm from "../../../pages/LawyerPages/Task/TaskModuleForms/CreateTaskListForm";
import DrawerTemplate from "../Cases/DrawerTemplate";
import PersonContactForm from "../Contacts/Contact Forms/PersonContactForm";
import CompanyContactForm from "../Contacts/Contact Forms/CompanyContactForm";
import RecordPaymentFrom from "../Billing/RecordPaymentFrom";
import CreateAccountForm from "../Accounts/AccountsForms/CreateAccountForm";
import NewTransactionForm from "../Accounts/AccountsForms/NewTransactionForm";
import TranferFundFrom from "../Accounts/AccountsForms/TranferFundFrom";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import useCommentNotifications from "./useCommentNotifications";

const Navbar = () => {
  const { showDialog, closeDialog } = useDialog();
  const { iconColors } = useCustomTheme();
  const muiTheme = useMuiTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searching, setSearching] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [createNewMenu, setCreateNewMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifyDrawer, setNotifyDrawer] = useState(false);
  const [hasOpenedNotifyDrawer, setHasOpenedNotifyDrawer] = useState(false);
  const profileNotify = localStorage.getItem("profileNotify");
  const open = Boolean(anchorEl);
  const { token, teamMemberLawyerId } = useSelector((data) => data.user);
  const { LoginUserData, firmData, loading } = useSelector(
    (state) => state.dashboard,
  );
  const primaryIconColor = iconColors?.primary || "#FFFFFF";
  const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const {
    notifications,
    unreadCount,
    loadingList: notificationsLoading,
    markNotificationRead,
    markThreadRead,
    markAllRead,
  } = useCommentNotifications({
    enabled: Boolean(token),
    loadList: hasOpenedNotifyDrawer,
    unreadOnly: false,
    pageSize: 12,
    pollingMs: 25000,
  });
  const shouldLoadUserData =
    !LoginUserData || Object.keys(LoginUserData).length === 0;
  const shouldLoadFirmData =
    !Array.isArray(firmData) || firmData.length === 0;

  useEffect(() => {
    if (token && shouldLoadUserData) {
      dispatch(
        getLoginUserData({
          url: `${backend_api}lawer/update-profile-lawer/`,
          token: token,
        }),
      );
    }

    if (token && shouldLoadFirmData) {
      dispatch(
        getFirmData({
          url: `${backend_api}firm/create-law-firm/`,
          token: token,
        }),
      );
    }
  }, [dispatch, shouldLoadFirmData, shouldLoadUserData, token]);

  const hasValidUserData =
    LoginUserData &&
    (LoginUserData.first_name ||
      LoginUserData.last_name ||
      LoginUserData.reminder_mail);

  const handleOpenFormDialog = (e, value) => {
    e.preventDefault();
    setCreateNewMenu(null);
    if (value === "add_team_member") {
      showDialog(<InviteUserForm />, {
        dialogTitle: "Invite Team Member",
      });
    } else if (value === "add_task") {
      showDialog(<CreateTaskForm />, {
        dialogTitle: "New Task",
      });
    } else if (value === "add_task_template") {
      showDialog(<CreateTaskTemplateForm />, {
        dialogTitle: "New Task Template",
      });
    } else if (value === "add_group_tasks") {
      showDialog(<CreateTaskListForm />, {
        dialogTitle: "Group your task",
      });
    } else if (value === "add_matter") {
      showDialog(<DrawerTemplate />, {
        dialogTitle: "Select Template",
      });
    } else if (value === "add_matter_template") {
      navigate("/dashboard/matter-template");
    } else if (value === "add_person") {
      showDialog(
        <PersonContactForm handleCloseAddContect={() => closeDialog()} />,
        {
          dialogTitle: "Create person",
          fullScreen: true,
          width: "100%",
        },
      );
    } else if (value === "add_company") {
      showDialog(
        <CompanyContactForm handleCloseAddContect={() => closeDialog()} />,
        {
          dialogTitle: "Create company",
          fullScreen: true,
          width: "100%",
        },
      );
    } else if (value === "record_payment") {
      showDialog(<RecordPaymentFrom />, {
        dialogTitle: "Record Payment",
        width: "40rem",
      });
    } else if (value === "new_trust_request") {
      navigate("/dashboard/bills?openTrustRequest=true");
    } else if (value === "new_account") {
      showDialog(<CreateAccountForm />, {
        dialogTitle: "Create Account",
        width: "48rem",
      });
    } else if (value === "new_transaction") {
      showDialog(<NewTransactionForm />, {
        dialogTitle: "New Transaction",
        width: "48rem",
      });
    } else if (value === "transfer_funds") {
      showDialog(<TranferFundFrom />, {
        dialogTitle: "Transfer Funds",
        width: "48rem",
      });
    }
  };

  const onlyFirstFirm =
    Array.isArray(firmData) && firmData.length > 0 ? firmData[0] : null;
  const hasFirm = Array.isArray(firmData) && firmData.length > 0;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleNotifyDrawer = (newOpen) => () => {
    if (newOpen) {
      setHasOpenedNotifyDrawer(true);
    }
    setNotifyDrawer(newOpen);
  };

  const items = ["Apple", "Banana", "Orange", "Mango", "Grapes", "Pineapple"];

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim()) {
      setFilteredItems(
        items.filter((item) => item.toLowerCase().includes(term.toLowerCase())),
      );
      setSearching(true);
    } else {
      setSearching(false);
      setFilteredItems([]);
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
    setSearching(false);
    setFilteredItems([]);
  };

  const searchPlaceholder = hasFirm
    ? `Welcome to ${onlyFirstFirm?.name}`
    : "No firm found - Click here to set up your firm";

  const handleSearchFieldClick = () => {
    if (!hasFirm) {
      navigate("/dashboard/settings/firm-profile");
      setMobileSearchOpen(false);
    }
  };

  const handleSearchResultSelect = (item) => {
    setSearchTerm(item);
    setSearching(false);
    setMobileSearchOpen(false);
  };

  const formatNotificationTime = (value) => {
    if (!value) return "Just now";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Just now";
    const diffMins = Math.round((Date.now() - date.getTime()) / 60000);
    if (diffMins <= 1) return "Just now";
    if (diffMins < 60) return `${diffMins} min ago`;
    const diffHours = Math.round(diffMins / 60);
    if (diffHours < 24) return `${diffHours} hr ago`;
    const diffDays = Math.round(diffHours / 24);
    if (diffDays < 7) return `${diffDays} d ago`;
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };

  const handleNotificationClick = async (notification) => {
    const isCommentThreadNotification = [
      "comment_created",
      "comment_replied",
    ].includes(notification?.event_type);

    try {
      if (isCommentThreadNotification && notification?.thread_comment_id) {
        await markThreadRead(notification.thread_comment_id);
      } else if (notification?.id) {
        await markNotificationRead(notification.id);
      }
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
    } finally {
      setNotifyDrawer(false);
      if (isCommentThreadNotification) {
        navigate("/dashboard/communications", {
          state: {
            commentNotification: {
              notificationId: notification?.id,
              commentId: notification?.comment_id,
              threadCommentId: notification?.thread_comment_id,
              entityType: notification?.entity_type,
              entityId: notification?.entity_id,
            },
          },
        });
        return;
      }

      if (notification?.entity_type === "task") {
        const caseId = notification?.entity_meta?.case_id;
        if (caseId) {
          navigate(`/dashboard/matter/${caseId}?tab=tasks&taskId=${notification?.entity_id}`);
          return;
        }
        navigate(`/dashboard/tasks?taskId=${notification?.entity_id}`);
        return;
      }

      if (notification?.entity_type === "bill") {
        const caseId = notification?.entity_meta?.case_id;
        if (caseId) {
          navigate(`/dashboard/matter/${caseId}?tab=bills&billId=${notification?.entity_id}`);
          return;
        }
        navigate(`/dashboard/bills?billId=${notification?.entity_id}`);
        return;
      }

      navigate("/dashboard/communications");
    }
  };

  const getNotificationActivityLabel = (notification) => {
    switch (notification?.event_type) {
      case "comment_replied":
        return "replied to a comment thread";
      case "task_assigned":
        return "assigned you a task";
      case "task_reminder":
        return "sent a task reminder";
      case "task_due_today":
        return "has a task due today";
      case "task_overdue":
        return "has an overdue task";
      case "bill_due_today":
        return "has a bill due today";
      default:
        return "posted a new comment";
    }
  };

  const searchFieldSx = {
    "& .MuiOutlinedInput-root": {
      borderColor: !hasFirm ? "warning.main" : undefined,
      cursor: !hasFirm ? "pointer" : "text",
      height: "2.5rem",
      bgcolor: "rgba(255, 255, 255, 0.7)",
      transition: "all 0.3s ease",
      borderRadius: "5rem",
      border: "1px solid #FFFFFF2E",
      background: "#FFFFFF40",
      boxShadow: "0 0rem 0.2rem 0 #1F268780",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "0.95rem",
      padding: "0.5rem 1rem",
      "&::placeholder": {
        opacity: 0.6,
        color: "#fff",
      },
    },
  };

  const renderSearchResults = (isMobile = false) =>
    searching ? (
      <Paper
        sx={{
          position: isMobile ? "static" : "absolute",
          top: isMobile ? "auto" : "100%",
          left: 0,
          right: 0,
          mt: "0.5rem",
          maxHeight: 200,
          overflowY: "auto",
          borderRadius: "0.75rem",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          zIndex: 9,
          bgcolor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          ...pageScrollStyle,
        }}
      >
        {filteredItems?.length > 0 ? (
          filteredItems?.map((item, index) => (
            <Box
              key={index}
              sx={{
                px: "1rem",
                py: "0.75rem",
                cursor: "pointer",
                transition: "background-color 0.2s",
                borderRadius: "0.5rem",
                mx: "0.5rem",
                my: "0.25rem",
                "&:hover": {
                  bgcolor: "rgba(25, 118, 210, 0.08)",
                },
              }}
              onClick={() => handleSearchResultSelect(item)}
            >
              <Typography sx={{ fontSize: "0.9rem" }}>{item}</Typography>
            </Box>
          ))
        ) : (
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography color="text.secondary" sx={{ fontSize: "0.9rem" }}>
              No results found
            </Typography>
          </Box>
        )}
      </Paper>
    ) : null;

  const renderSearchInput = (isMobile = false) => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: isMobile ? "100%" : "25rem",
      }}
    >
      <TextField
        placeholder={searchPlaceholder}
        value={searchTerm}
        onChange={handleSearchChange}
        onClick={handleSearchFieldClick}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon
                sx={{
                  color: "#fff",
                  fontSize: "1.4rem",
                }}
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {searchTerm && (
                <IconButton size="small" onClick={clearSearch} sx={{ padding: "0.25rem" }}>
                  <ClearRounded sx={{ fontSize: "1.2rem" }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={searchFieldSx}
      />

      {renderSearchResults(isMobile)}
    </Box>
  );

  const handleLoginAgain = () => {
    handleClose();
    // Clear all stored data
    dispatch(logout());
    persistor.purge();
    localStorage.clear();
    sessionStorage.clear();
    // Navigate to login page
    navigate("/login");
  };

  const handleLogout = () => {
    dispatch(logout());
    persistor.purge();
    localStorage.clear();
    sessionStorage.clear();
    handleClose();
    navigate("/login");
  };

  useEffect(() => {
    const allFields = [
      "first_name",
      "last_name",
      "birth_date",
      "gender",
      "mobile",
      "address_1",
      "city",
      "state",
      "country",
      "pincode",
    ];
    if (LoginUserData) {
      const hasEmptyFields = allFields.some((field) => {
        const value = LoginUserData[field];
        return (
          value === undefined ||
          value === null ||
          value === "" ||
          (field === "birth_date" && !value) ||
          (typeof value === "string" && value.trim() === "")
        );
      });

      if (hasEmptyFields) {
        const filledFields = allFields.filter((field) => {
          const value = LoginUserData[field];
          return (
            value !== undefined &&
            value !== null &&
            value !== "" &&
            (field !== "birth_date" || value) &&
            (typeof value !== "string" || value.trim() !== "")
          );
        });

        const progress = Math.round(
          (filledFields.length / allFields.length) * 50,
        );

        localStorage.setItem("profileNotify", "true");
        localStorage.setItem("profileCompleted", progress.toString());
      }
    }
  }, [LoginUserData]);

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "10rem",
        px: "0.4rem",
        bgcolor: "primary.main",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isSmallScreen ? "flex-end" : "space-between",
          gap: "0.5rem",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: "25rem",
            display: { xs: "none", sm: "block" },
          }}
        >
          <TextField
            placeholder={
              hasFirm
                ? `Welcome to ${onlyFirstFirm?.name}`
                : "No firm found - Click here to set up your firm"
            }
            value={searchTerm}
            onChange={handleSearchChange}
            onClick={() => {
              if (!hasFirm) {
                navigate("/dashboard/settings/firm-profile");
              }
            }}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon
                    sx={{
                      color: "#fff",
                      fontSize: "1.4rem",
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {searchTerm && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSearchTerm("");
                        setSearching(false);
                      }}
                      sx={{ padding: "0.25rem" }}
                    >
                      <ClearRounded sx={{ fontSize: "1.2rem" }} />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: !hasFirm ? "warning.main" : undefined,
                cursor: !hasFirm ? "pointer" : "text",
                height: "2.5rem",
                bgcolor: "rgba(255, 255, 255, 0.7)",
                transition: "all 0.3s ease",
                borderRadius: "5rem",
                border: "1px solid #FFFFFF2E",
                background: "#FFFFFF40",
                boxShadow: "0 0rem 0.2rem 0 #1F268780",
                backdropFilter: "blur(4px)",
                WebkitBackdropFilter: "blur(4px)",

                "& fieldset": {
                  border: "none",
                },
              },

              "& .MuiOutlinedInput-input": {
                fontSize: "0.95rem",
                padding: "0.5rem 1rem",

                "&::placeholder": {
                  opacity: 0.6,
                  color: "#fff",
                },
              },
            }}
          />

          {searching && (
            <Paper
              sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                mt: "0.5rem",
                maxHeight: 200,
                overflowY: "auto",
                borderRadius: "0.75rem",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                zIndex: 9,
                bgcolor: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                ...pageScrollStyle,
              }}
            >
              {filteredItems?.length > 0 ? (
                filteredItems?.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      px: "1rem",
                      py: "0.75rem",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                      borderRadius: "0.5rem",
                      mx: "0.5rem",
                      my: "0.25rem",
                      "&:hover": {
                        bgcolor: "rgba(25, 118, 210, 0.08)",
                      },
                    }}
                    onClick={() => {
                      setSearchTerm(item);
                      setSearching(false);
                    }}
                  >
                    <Typography sx={{ fontSize: "0.9rem" }}>{item}</Typography>
                  </Box>
                ))
              ) : (
                <Box sx={{ px: 2, py: 1.5 }}>
                  <Typography
                    color="text.secondary"
                    sx={{ fontSize: "0.9rem" }}
                  >
                    No results found
                  </Typography>
                </Box>
              )}
            </Paper>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: "0.25rem", sm: "0.5rem" },
          }}
        >
          {isSmallScreen ? (
            <Tooltip title="Search"  placement="bottom" arrow>
              <IconButton onClick={() => setMobileSearchOpen(true)}>
                <SearchRoundedIcon
                  sx={{ fontSize: "1.5rem", color: primaryIconColor }}
                />
              </IconButton>
            </Tooltip>
          ) : null}
          <Box sx={{ position: "relative", display: { xs: "none", sm: "block" } }}>
            <Stopwatch />
          </Box>
          {/* Notification Bell */}
          <Tooltip title="Notifications"  placement="bottom" arrow>
            <Box sx={{ position: "relative" }}>
              <IconButton
                onClick={toggleNotifyDrawer(true)}
                sx={{
                  animation: profileNotify
                    ? "shake 0.8s cubic-bezier(0.36, 0.07, 0.19, 0.97) both"
                    : "none",
                  "@keyframes shake": {
                    "10%, 90%": { transform: "translate3d(-1px, 0, 0)" },
                    "20%, 80%": { transform: "translate3d(2px, 0, 0)" },
                    "30%, 50%, 70%": { transform: "translate3d(-4px, 0, 0)" },
                    "40%, 60%": { transform: "translate3d(4px, 0, 0)" },
                  },
                }}
              >
                <NotificationsActiveRoundedIcon
                  sx={{ fontSize: "1.6rem", color: primaryIconColor }}
                />
              </IconButton>
              {(profileNotify || unreadCount > 0) && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 2,
                    right: 2,
                    minWidth: unreadCount > 0 ? "1.2rem" : "10px",
                    height: unreadCount > 0 ? "1.2rem" : "10px",
                    px: unreadCount > 0 ? "0.18rem" : 0,
                    bgcolor: "red",
                    color: "#fff",
                    borderRadius: "999px",
                    display: "grid",
                    placeItems: "center",
                    fontSize: "0.68rem",
                    fontWeight: 700,
                  }}
                >
                  {unreadCount > 0 ? Math.min(unreadCount, 9) : ""}
                </Box>
              )}
            </Box>
          </Tooltip>
          <Tooltip title="Create New"  placement="bottom" arrow>
            <IconButton
              color="white"
              onClick={(e) => setCreateNewMenu(e.currentTarget)}
            >
              <AddRoundedIcon
                sx={{ fontSize: "1.6rem", color: primaryIconColor }}
              />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={createNewMenu}
            open={Boolean(createNewMenu)}
            onClose={() => setCreateNewMenu(null)}
            PaperProps={{
              elevation: 4,
              sx: {
                mt: "1rem",
                minWidth: 200,
              },
            }}
          >
            {createNewOpenFormName?.map((forms, i) => (
              <MenuItem
                key={i}
                onClick={(e) => {
                  setCreateNewMenu(null);
                  handleOpenFormDialog(e, forms?.value);
                }}
              >
                {forms?.label}
              </MenuItem>
            ))}
          </Menu>

          <Tooltip
            title={hasValidUserData ? "Account settings" : "Login again"} 
          >
            <IconButton onClick={handleClick}>
              <Box
                sx={{
                  height: "2.4rem",
                  width: "2.4rem",
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              >
                {loading ? (
                  <Skeleton
                    variant="circular"
                    width="2.4rem"
                    height="2.4rem"
                    animation="wave"
                    sx={{
                      bgcolor: "rgba(255, 255, 255, 0.1)",
                    }}
                  />
                ) : hasValidUserData ? (
                  <UserAvatar
                    firstName={
                      LoginUserData?.first_name || LoginUserData?.reminder_mail
                    }
                    imgSrc={LoginUserData?.avatar}
                    height={"2.4rem"}
                    width={"2.4rem"}
                  />
                ) : (
                  <Box
                    sx={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "50%",
                    }}
                  >
                    <PersonRounded sx={{ color: "#fff", fontSize: "1.5rem" }} />
                  </Box>
                )}
              </Box>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 4,
              sx: {
                p: "0rem",
                mt: "1rem",
                minWidth: 200,
              },
            }}
          >
            {hasValidUserData ? (
              <>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate("/dashboard/settings/profile");
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "1rem" }}
                  >
                    <UserAvatar
                      firstName={LoginUserData?.first_name}
                      imgSrc={LoginUserData?.avatar}
                      height={"2.2rem"}
                      width={"2.2rem"}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "10rem",
                      }}
                    >
                      {LoginUserData?.first_name || LoginUserData?.last_name
                        ? `${LoginUserData?.first_name ?? ""} ${
                            LoginUserData?.last_name ?? ""
                          }`.trim()
                        : LoginUserData?.reminder_mail || "Profile"}
                    </Typography>
                  </Box>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleLogout} color="error" alignItems="end">
                  <ListItemIcon>
                    <LogoutRounded color="error" sx={{ fontSize: "1.5rem" }} />
                  </ListItemIcon>
                  <Typography variant="body1" sx={{ fontSize: "1rem" }}>
                    Logout
                  </Typography>
                </MenuItem>
              </>
            ) : (
              <>
                <MenuItem onClick={handleLoginAgain}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      width: "100%",
                    }}
                  >
                    <ListItemIcon>
                      <LoginRounded
                        color="primary"
                        sx={{ fontSize: "1.5rem" }}
                      />
                    </ListItemIcon>
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 500,
                          color: "primary.main",
                        }}
                      >
                        Login Again
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.75rem",
                          color: "text.secondary",
                          display: "block",
                          mt: "0.125rem",
                        }}
                      >
                        Session expired or invalid
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      </Box>

      <Drawer
        anchor="top"
        open={mobileSearchOpen}
        onClose={() => setMobileSearchOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            p: "1rem",
            borderRadius: "0 0 20px 20px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0.75rem",
            mb: "0.75rem",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Search
          </Typography>
          <IconButton onClick={() => setMobileSearchOpen(false)} color="error">
            <CloseRounded />
          </IconButton>
        </Box>
        {renderSearchInput(true)}
      </Drawer>

      {/* =------------------------------------notification drawer ------------------------------------------------- */}
      <Drawer
        anchor="right"
        open={notifyDrawer}
        onClose={toggleNotifyDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", sm: "360px" },
            p: "1rem",
            borderRadius: "8px 0 0 8px",
          },
        }}
      >
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb="1rem"
        >
          <Typography variant="h6" fontWeight="600">
            Notifications
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {unreadCount > 0 ? (
              <Button
                size="small"
                variant="text"
                onClick={markAllRead}
                sx={{ textTransform: "none" }}
              >
                Mark all read
              </Button>
            ) : null}
            <Button
              size="small"
              variant="text"
              onClick={() => {
                setNotifyDrawer(false);
                navigate("/dashboard/communications");
              }}
              sx={{ textTransform: "none" }}
            >
              Open communication
            </Button>
            <IconButton onClick={toggleNotifyDrawer(false)} color={"error"}>
              <CloseRounded />
            </IconButton>
          </Box>
        </Box>

        {profileNotify ? (
          <Box
            sx={{
              borderRadius: "12px",
              p: "1rem",
              mb: "1rem",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)",
              cursor: "pointer",
            }}
            onClick={() => navigate("/dashboard/profile")}
          >
            <Avatar
              sx={{
                backgroundColor: "#4f46e5",
                width: "48px",
                height: "48px",
              }}
            >
              <PersonRounded />
            </Avatar>
            <Box>
              <Typography fontWeight="500" fontSize="1rem">
                Complete your Profile
              </Typography>
              <Typography fontSize="0.875rem" color="#9ca3af">
                for better experience
              </Typography>
            </Box>
            <Box>
              {/* <ProfileCircularProgress value={profileCompleted} /> */}
            </Box>
          </Box>
        ) : null}

        {hasOpenedNotifyDrawer ? (
          notificationsLoading ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
              {[1, 2, 3].map((item) => (
                <Skeleton
                  key={item}
                  variant="rounded"
                  height={76}
                  sx={{ borderRadius: "16px" }}
                />
              ))}
            </Box>
          ) : notifications.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                maxHeight: "calc(100vh - 10rem)",
                overflowY: "auto",
                pr: 0.5,
                ...pageScrollStyle,
              }}
            >
              {notifications.map((notification) => (
                <Box
                  key={notification.id}
                  onClick={() => handleNotificationClick(notification)}
                  sx={{
                    borderRadius: "16px",
                    border: notification.is_read
                      ? "1px solid rgba(148,163,184,0.18)"
                      : "1px solid rgba(59,130,246,0.2)",
                    bgcolor: notification.is_read
                      ? "#FFFFFF"
                      : "rgba(59,130,246,0.06)",
                    p: 1.2,
                    cursor: "pointer",
                    transition: "all 0.18s ease",
                    "&:hover": {
                      transform: "translateY(-1px)",
                      boxShadow: "0 12px 24px rgba(15,23,42,0.08)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 34,
                        height: 34,
                        bgcolor: notification.is_read
                          ? "rgba(148,163,184,0.18)"
                          : "rgba(37,99,235,0.14)",
                        color: notification.is_read ? "#64748B" : "#2563EB",
                        fontSize: "0.75rem",
                        fontWeight: 700,
                      }}
                    >
                      {(notification.actor?.name || "U")
                        .split(" ")
                        .filter(Boolean)
                        .slice(0, 2)
                        .map((part) => part[0]?.toUpperCase() || "")
                        .join("")}
                    </Avatar>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                          mb: 0.4,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 700, minWidth: 0 }}
                        >
                          {notification.actor?.name || "Team member"}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ flexShrink: 0 }}
                        >
                          {formatNotificationTime(notification.created_at)}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.84rem", lineHeight: 1.5 }}
                      >
                        {getNotificationActivityLabel(notification)}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          display: "block",
                          mt: 0.45,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {notification.entity_label || `#${notification.entity_id}`}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          mt: 0.65,
                          color: "text.secondary",
                          lineHeight: 1.45,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {notification.comment_preview}
                      </Typography>
                    </Box>
                    {!notification.is_read ? (
                      <Box
                        sx={{
                          width: 9,
                          height: 9,
                          borderRadius: "999px",
                          bgcolor: "#2563EB",
                          mt: 0.7,
                          flexShrink: 0,
                        }}
                      />
                    ) : null}
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                borderRadius: "16px",
                border: "1px dashed rgba(148,163,184,0.35)",
                p: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                No notifications yet
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Public comment activity from your team will appear here.
              </Typography>
            </Box>
          )
        ) : null}
      </Drawer>
    </Box>
  );
};

export default Navbar;
